import { SerializableObject } from '../../common-react/core';

/**
 * NOTE: Existing cards have the first 12 digits of the card number replaced with asterisk and the security code is null.
 */
export class CardVerificationResponse extends SerializableObject {
  public cardVerificationRawResponse?: string;
  public isSuccess: boolean;
}
